import { IconProp } from '@benzinga/core-ui';

export interface TabType {
  icon?: IconProp;
  title: string;
  description?: string;
  href?: string;
}

export { TabNavItem } from './TabNavItem';
export { TabContent } from './TabContent';
export { TabContext, TabContextProvider } from './TabContext';
